






































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Getter, Mutation, State } from 'vuex-class';
import { SwTabGroup, SwTabPage, TabProps } from '@libs-uuif/shared/sw-tab-layout';
import { MswPageTheme } from '@/shared/msw-types';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { currentUserKey } from '@/shared/msw-constants';
import * as decode from 'jwt-decode';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { RootStoreState } from '@/store';
import { MswApiService } from '../../msw-api-service';
const cssPrefix = 'user-group-extension';

@Component({
  components: {
    SwCheckbox,
    SwForm,
    SwFormRow,
    SwIcon,
    SwScrollView,
    SwSelect,
    SwTabGroup,
    SwIconButton,
    SwTabPage,
  },
})

export default class UserGroupExtension extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Getter
  effectivePageTheme: MswPageTheme;

  @Prop({ type: Array, required: true })
  selectedUserGroup: any;

  @Prop({ type: Boolean, required: true })
  disableCustomerTab: boolean;

  @Prop({ type: String, required: false })
  tabHeight: string;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @Prop({ type:String, required: true })
  selectedTab: string;

  @Prop({ type: Boolean, required : false })
  callUpdatePermission: boolean;

  @Prop({ type:String, required: false })
  loadCustomerChange: string;

  @Prop({ type: String, required: true })
  name : string;

  formLabelWidth:string = '40%';
  extensionUserGroupTabId: string = 'user-groups-users-tab';
  userJsonResponse : any = [];
  usersList : any = [];
  customersList: any = [];
  permissionList: any = [];
  customerTab: any = '';
  editMode: boolean = false;
  userTab: any = '';
  permissionTab: any = '';
  userGroupTabsProps: TabProps[] = [
    { tabId: 'user-groups-customer-tab', label: this.customerTab },
    { tabId: 'user-groups-users-tab', label: this.userTab },
    { tabId: 'user-groups-permission-tab', label: this.permissionTab },
  ];
  customerTabHeight: string = '';
  permissionCheckBox : boolean[] = [];
  @State((state: RootStoreState) => state.MswUserGroupStoreModule.addUserFlag)
  addUserFlag: boolean;
  permissionChanged : boolean = false;
  created() {
    // debugger;
    this.customerTab = this.$t('userGroups.Customers');
    this.userTab = this.$t('userGroups.users');
    this.permissionTab = this.$t('userGroups.permissions');
    this.userGroupTabsProps = [
      { tabId: 'user-groups-customer-tab', label: this.customerTab , disabled: this.disableCustomerTab },
      { tabId: 'user-groups-users-tab', label: this.userTab },
      { tabId: 'user-groups-permission-tab', label: this.permissionTab },
    ];
    this.loadGroupContent();
    this.loadSelectedTab();
  }

  @Watch('callUpdatePermission')
  updatePermissionChanged() {
    console.warn('updatechanged no');
    if (this.callUpdatePermission) {
      console.warn('changes in user');
      this.permissionChanged = true;
      this.loadGroupContent();
    }
  }

  @Watch('loadCustomerChange')
  loadCustomerChanged() {
    if (this.loadCustomerChange !== '') {
      this.loadCustomerOnChange(this.loadCustomerChange);
    }
  }

  computed() {
    this.loadGroupContent();
  }

  get isOrgBased() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    console.warn('checking orgbased from token', token.hasOwnProperty('orgbased') && token?.orgbased === 'YES');
    return token.hasOwnProperty('orgbased') && token?.orgbased === 'YES';
  }

  changeTabId(value: string) {
    if (value === 'user-groups-users-tab') {
      this.$emit('change-tab-id', 'user-groups-users-tab', true);
      // this.setHelpContentId({ helpId: 'users-tab-users' });
      this.setHelpId('user-groups-users-tab');
    } else if (value === 'user-groups-customer-tab') {
      this.$emit('change-tab-id', 'user-groups-customer-tab', true);
      // this.setHelpContentId({ helpId: 'users-tab-customers' });
      this.setHelpId('user-groups-customer-tab');
    } else if (value === 'user-groups-permission-tab') {
      this.$emit('change-tab-id', 'user-groups-permission-tab', true);
      // this.setHelpContentId({ helpId: 'users-tab-permissions' });
      this.setHelpId('user-groups-permission-tab');
    }
    window.parent.postMessage({ showHelp : true }, '*');
  }
  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
    window.parent.postMessage({ route: 'user-groups', helpId: temp }, '*');
  }
  removeUser(user: any, index: any) {
    console.warn(user, index);
    this.$emit('remove-user', user);
  }

  removeCustomer(index: any) {
    this.$emit('remove-customer', index);
  }

  @Watch('selectedUserGroup')
  loadGroupContent() {
    // debugger;
    console.warn('created');
    console.warn(this.userJsonResponse);
    console.warn(this.selectedUserGroup[0]);
    this.customersList = this.userJsonResponse.hasOwnProperty('assignedProductGroup') ? this.userJsonResponse.assignedProductGroup : [];
    if (this.userJsonResponse.partyGroupId !== this.selectedUserGroup[0].partyGroupId
      // tslint:disable-next-line:max-line-length
      || (this.userJsonResponse.usersForUserGroup && this.selectedUserGroup[0].usersForUserGroup && (this.userJsonResponse.usersForUserGroup.length !== this.selectedUserGroup[0].usersForUserGroup.length))
      || this.userJsonResponse.productGroupName !== this.selectedUserGroup[0].productGroupName || this.permissionChanged
    ) {
      // debugger;
      console.warn('created1');
      this.permissionChanged = false;
      this.customerTabHeight = (Number(this.tabHeight.replace('px', '')) +  10).toString()
      .concat('px');
      // this.extensionUserGroupTabId = this.selectedTab;
      // this.extensionUserGroupTabId = 'users';
      console.warn('pemission changed with value');
      this.userJsonResponse = this.selectedUserGroup[0].hasOwnProperty('usersForUserGroup') ? this.selectedUserGroup[0] : [];
      this.usersList = this.userJsonResponse.hasOwnProperty('usersForUserGroup') ? this.sortUsersList(this.userJsonResponse.usersForUserGroup) : [];
      this.customersList = this.userJsonResponse.hasOwnProperty('assignedProductGroup') ? this.userJsonResponse.assignedProductGroup : [];
      console.warn(this.customersList);
      console.warn(this.selectedUserGroup[0]);
      // tslint:disable-next-line:max-line-length
      console.warn(this.userJsonResponse.hasOwnProperty('permissionsForUserGroup'));
      if (!this.userJsonResponse.hasOwnProperty('permissionsForUserGroup')) {
        let permissionObj: any = {};
        let tempObj : any = this.userJsonResponse;
        this.$store.commit('startLoading');
        MswApiService.createCustomer.getUserGroupPermissions(this.userJsonResponse.partyGroupId)
            .then((respPermission: any) => {
              permissionObj = respPermission.hasOwnProperty('content') ? respPermission.content.hasOwnProperty('PartyGroupPermissionSections') ?
              respPermission.content.PartyGroupPermissionSections : [] : [];
              tempObj = Object.assign(tempObj, {
                // usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup : [],
                permissionsForUserGroup: permissionObj,
                // initialUsers: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
                //   return users;
                // }) : [],
              });
              this.userJsonResponse = tempObj;
              // tslint:disable-next-line:max-line-length
              this.permissionList = this.userJsonResponse.hasOwnProperty('permissionsForUserGroup') ? this.userJsonResponse.permissionsForUserGroup.map((obj: any) => {
                this.permissionCheckBox.push(false);
                const editedPermissions = obj.partyGroupPermissionItems.map((ele: any) => {
                  let valueSelected = '';
                  ele.permissionChoices.map((item: any) => {
                    if  (item.isSelected === 'TRUE') {
                      valueSelected = item.permissionItemChoiceValue;
                    }
                  });
                  return {
                    functionalityname: ele.functionalityname,
                    permissionChoices: ele.permissionChoices,
                    value: valueSelected,
                  };
                });
                return {
                  partyGroupPermissionSectionName: obj.partyGroupPermissionSectionName,
                  partyGroupPermissionItems: editedPermissions,
                };
              }) : [];
              // disabling the code as we are getting info in user group tab however keeping the logic if we may call this in future.
              if (false) {
                MswApiService.createCustomer.listProductGroupForUserGroup(this.userJsonResponse.partyGroupId)
            .then((customerResponse: any) => {
              if (customerResponse.operationStatus === 'OK') {
                this.$store.commit('stopLoading');
                const assignedProductGroup = customerResponse.hasOwnProperty('content') ? customerResponse.content.hasOwnProperty('assignedProductGroup') ?
                  customerResponse.content.assignedProductGroup : [] : [];
                const availableProductGroup = customerResponse.hasOwnProperty('content') ? customerResponse.content.hasOwnProperty('availbleProductGroup') ?
                  customerResponse.content.availbleProductGroup : [] : [];
                this.customersList = assignedProductGroup;
                const userGroupObj = {
                  assigProductGroup : assignedProductGroup,
                  availProductGroup : availableProductGroup,
                };
                this.$emit('listProductGroupForUserGroup', userGroupObj);
                console.warn(userGroupObj);
              }
            });
              } else {
                this.$store.commit('stopLoading');
              }
            });
      } else {
        console.warn(this.userJsonResponse);
        console.warn(this.userJsonResponse.hasOwnProperty('permissionsForUserGroup'));
        // tslint:disable-next-line:max-line-length
        this.permissionList = this.userJsonResponse.hasOwnProperty('permissionsForUserGroup') ? this.userJsonResponse.permissionsForUserGroup.map((obj: any) => {
          this.permissionCheckBox.push(false);
          const editedPermissions = obj.partyGroupPermissionItems.map((ele: any) => {
            let valueSelected = '';
            ele.permissionChoices.map((item: any) => {
              if  (item.isSelected === 'TRUE') {
                valueSelected = item.permissionItemChoiceValue;
              }
            });
            return {
              functionalityname: ele.functionalityname,
              permissionChoices: ele.permissionChoices,
              value: valueSelected,
            };
          });
          return {
            partyGroupPermissionSectionName: obj.partyGroupPermissionSectionName,
            partyGroupPermissionItems: editedPermissions,
          };
        }) : [];
      }
      if (!this.userJsonResponse.hasOwnProperty('usersForUserGroup') && false) {
        let tempObj : any = this.userJsonResponse;
        let assignedUsers: any = {};
        MswApiService.createCustomer.listUsersForUserGroup(this.userJsonResponse.partyGroupId)
        .then((resp: any) => {
          assignedUsers = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('assignedUsers') ? resp.content.assignedUsers : [] : [];
          tempObj = Object.assign(tempObj, {
            usersForUserGroup: assignedUsers,
          });
          console.warn(assignedUsers);
          this.userJsonResponse = tempObj;
        });
      }
    }
  }

  loadCustomerOnChange(partyGroupId : any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.listProductGroupForUserGroup(partyGroupId)
            .then((customerResponse: any) => {
              if (customerResponse.operationStatus === 'OK') {
                this.$store.commit('stopLoading');
                const assignedProductGroup = customerResponse.hasOwnProperty('content') ? customerResponse.content.hasOwnProperty('assignedProductGroup') ?
                  customerResponse.content.assignedProductGroup : [] : [];
                const availableProductGroup = customerResponse.hasOwnProperty('content') ? customerResponse.content.hasOwnProperty('availbleProductGroup') ?
                  customerResponse.content.availbleProductGroup : [] : [];
                this.customersList = assignedProductGroup;
                const userGroupObj = {
                  assigProductGroup : assignedProductGroup,
                  availProductGroup : availableProductGroup,
                };
                this.$emit('listProductGroupForUserGroup', userGroupObj);
                console.warn(userGroupObj);
              }
            });
  }

  @Watch('selectedTab')
  loadSelectedTab() {
    this.extensionUserGroupTabId = this.selectedTab;
    if (this.selectedTab === 'user-groups-help') {
      this.extensionUserGroupTabId = 'user-groups-users-tab';
    }
  }
  addNewUser() {
    this.permissionChanged = true;
    this.$emit('add-new-user', this.userJsonResponse.partyGroupId);
  }
  addNewCustomer() {
    this.$emit('add-new-customer', this.userJsonResponse.partyGroupId);
  }

  closeExtension() {
    // this.$emit('close-extension');
    this.$emit('change-tab-id', 'user-groups-help', false);
    const temp:string[] = [];
    temp.push('users-tab-user-groups');
    this.setHelpContentId({ helpId:temp });
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
  }

  onChange(value: string, functionality: any, partyGroupPermissionSectionName: string) {
    // tslint:disable-next-line:no-unused
    // this.permissionCheckBox.forEach((each : any , index:any) => {
    //   this.$set(this.permissionCheckBox, index, false);
    // });
    this.permissionChanged = true;
    this.$emit('change-permission', this.userJsonResponse.partyGroupId, value, functionality, partyGroupPermissionSectionName);
  }

  getPermissionOptions(data: any): SelectOption[] {
    return data.map((obj: any) => {
      return {
        id: obj.permissionItemChoiceValue,
        value: obj.permissionItemChoiceValue,
        label: obj.permssionItemChoiceName,
      };
    });
  }

  getPermissionValue(data: any) {
    let selectedMode = '';
    data.map((obj: any) => {
      if (obj.isSelected === 'TRUE') {
        selectedMode = obj.permissionItemChoiceValue;
      }
    });
    return selectedMode;
  }

  getPermissionName(data: any) {
    let selectedModeName = '';
    data.map((obj: any) => {
      if (obj.isSelected === 'TRUE') {
        selectedModeName = obj.permssionItemChoiceName;
      }
    });
    return selectedModeName;
  }

  sortUsersList(usersList:any) {
    const finalUsersList = usersList.sort((a:any, b:any) => {
      if (a.name !== 'default') {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      }
    });
    return finalUsersList;
  }

}
